import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Contact: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m540 660h-70c-8.28 0-15-6.72-15-15s6.72-15 15-15h70c33.08 0 60-28.79 60-64.17v-19.58c0-8.28 6.72-15 15-15s15 6.72 15 15v19.58c0 51.92-40.37 94.17-90 94.17z' />
    <path d='m180 570h-30v-200c0-66.65 24.88-129.35 70.07-176.54 45.35-47.37 105.7-73.46 169.93-73.46s124.58 26.09 169.93 73.46c45.18 47.19 70.07 109.89 70.07 176.54v176.25h-30v-176.25c0-121.31-94.21-220-210-220s-210 98.69-210 220z' />
    <path d='m300.62 570h-130.62v-30h100.62v-125c0-13.79-11.21-25-25-25h-65.62v-30h65.62c30.33 0 55 24.67 55 55z' />
    <path d='m610 569.17h-130v-154.17c0-30.33 24.67-55 55-55h75.62v30h-75.62c-13.79 0-25 11.21-25 25v124.17h100z' />
    <path d='m420 660h70s0-30 0-30h-40c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

Contact.displayName = 'Contact';

export default Contact;
